const login = {
  name: 'examPracticeReportLogin',
  path: '',
  component: resolve => require(['../../../../../../pages/portal/sbs/exam/practice-report/login'], resolve)
}

export default login
